/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import type { FieldValues, FormProviderProps } from "react-hook-form";
import { FormProvider } from "react-hook-form";

type FormProps<
  TFieldValues extends FieldValues,
  TContext = any,
  TTransformedValues extends FieldValues | undefined = undefined,
> = {
  formCSS?: Interpolation;
  formProps: React.HTMLAttributes<HTMLFormElement>;
} & FormProviderProps<TFieldValues, TContext, TTransformedValues>;

export const Form = <
  TFieldValues extends FieldValues,
  TContext = any,
  TTransformedValues extends FieldValues | undefined = undefined,
>({
  formProps,
  formCSS,
  ...props
}: FormProps<TFieldValues, TContext, TTransformedValues>) => {
  return (
    <FormProvider {...props}>
      <form css={formCSS} {...formProps}>
        {props.children}
      </form>
    </FormProvider>
  );
};

Form.displayName = "Form";
